export function selectAttachmentReducer(selectedIds, action) {
    if (selectedIds) {
        if (selectedIds.has(action.payload.id)) {
            selectedIds.delete(action.payload.id);
        }
        else {
            selectedIds.add(action.payload.id);
        }
    }
    return new Set(selectedIds);
}
//# sourceMappingURL=selectAttachmentReducer.js.map